import { lowerCase, upperFirst } from 'lodash';

/**
 *  fooBar -> Foo Bar, foo-bar -> Foo Bar
 * */
export function toTitleCase(input: string) {
    let translated: string;
    try {
        translated = lowerCase(input)
            .split(' ')
            .map((word) => upperFirst(word))
            .join(' ');
    } catch (error) {
        translated = input;
    }
    return translated;
}
